import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { autobind } from 'office-ui-fabric-react/lib/Utilities';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
var styles = require('./OptionConfirmationDialog.scss');
/**
 * A Dialog to show three options: save your current changes, discard them, or go back and edit them.
 * This is implemented rather than using owa-confirm-dialog because that system doesn't support three options,
 * and would add unneeded complexity to that package for a one-off scenario.
 * Additionally, this may end up styled differently in the future, with stacked full-width buttons, rather than
 * using the default Dialog styling of a row of footer buttons.
 */
var OptionConfirmationDialog = /** @class */ (function (_super) {
    tslib_1.__extends(OptionConfirmationDialog, _super);
    function OptionConfirmationDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isShown: false,
        };
        return _this;
    }
    OptionConfirmationDialog.prototype.componentDidMount = function () {
        this.setState({
            isShown: true,
        });
    };
    OptionConfirmationDialog.prototype.render = function () {
        return (React.createElement(Dialog, { isOpen: this.state.isShown, type: DialogType.normal, onDismiss: this.onDismiss, onDismissed: this.onDismissed, className: styles.dialog, title: strings.optionsConfirmationDialog_title, subText: strings.optionsConfirmationDialog_subtitle },
            React.createElement(DialogFooter, null,
                React.createElement(PrimaryButton, { className: styles.footerButton, text: strings.optionsConfirmationDialog_save, onClick: this.onSave, disabled: this.props.shouldDisableSaveButton }),
                React.createElement(DefaultButton, { className: styles.footerButton, text: strings.optionsConfirmationDialog_discard, onClick: this.onDiscard }),
                React.createElement(DefaultButton, { className: styles.footerButton, text: strings.optionsConfirmationDialog_cancel, onClick: this.onCancel }))));
    };
    OptionConfirmationDialog.prototype.onSave = function () {
        this.onDismiss();
        this.props.onSave();
    };
    OptionConfirmationDialog.prototype.onDiscard = function () {
        this.onDismiss();
        this.props.onDiscard();
    };
    OptionConfirmationDialog.prototype.onCancel = function () {
        this.onDismiss();
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    };
    OptionConfirmationDialog.prototype.onDismiss = function () {
        this.setState({
            isShown: false,
        });
    };
    OptionConfirmationDialog.prototype.onDismissed = function () {
        this.props.onClose();
    };
    tslib_1.__decorate([
        autobind
    ], OptionConfirmationDialog.prototype, "onSave", null);
    tslib_1.__decorate([
        autobind
    ], OptionConfirmationDialog.prototype, "onDiscard", null);
    tslib_1.__decorate([
        autobind
    ], OptionConfirmationDialog.prototype, "onCancel", null);
    tslib_1.__decorate([
        autobind
    ], OptionConfirmationDialog.prototype, "onDismiss", null);
    tslib_1.__decorate([
        autobind
    ], OptionConfirmationDialog.prototype, "onDismissed", null);
    OptionConfirmationDialog = tslib_1.__decorate([
        observer
    ], OptionConfirmationDialog);
    return OptionConfirmationDialog;
}(React.Component));
var confirmOptionContainer;
export default function confirmOptionNavigation(props) {
    if (!confirmOptionContainer) {
        confirmOptionContainer = document.createElement('div');
        document.body.appendChild(confirmOptionContainer);
    }
    ReactDOM.render(React.createElement(OptionConfirmationDialog, tslib_1.__assign({}, props, { onClose: function () {
            ReactDOM.unmountComponentAtNode(confirmOptionContainer);
        } })), confirmOptionContainer);
}
//# sourceMappingURL=OptionConfirmationDialog.js.map